export default "__VITE_ASSET__DD6AGrJI__"